export default __webpack_public_path__ + "static/pull.repairClothes-48308cb8d73089fd8c80c1e378ba476a.jpg";